import { getDefaultState } from './constants.js';

export default {
  SET_PURCHASE_TICKET(state, purchaseTicket) {
    state.purchaseTicket = { ...purchaseTicket };
  },

  RESET_PURCHASE_TICKET(state, purchaseTicket) {
    state.purchaseTicket = purchaseTicket
      ? { ...purchaseTicket }
      : { ...getDefaultState().purchaseTicket };
  },

  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
};
